import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('embargo', '/embargoes')
const reducer = generator.generate()

export default reducer
